import React from 'react';
import NationalRoadSafty2023 from 'views/NationalRoadSafty2023';

const LifeSkillPage = () => {
  return <NationalRoadSafty2023/>;
};

export default LifeSkillPage;